import React, {Component} from "react";
import {RouteComponentProps, withRouter} from "react-router-dom";
import {LanguageService} from "../language/LanguageService";
import styled from "styled-components";
import {TabItem, TitleBarContainer, TitleBarContents, TitleBarItem} from "../style/CommonStyledComponents";
import {CategoryRepository} from "../repositories/category/CategoryRepository";
import CategoryStore from "../repositories/category/CategoryStore";
import {Tab, TabList, TabPanel, Tabs} from 'react-tabs';
import {emptySsqDataDocument, ISsqDataDocMinInfo, ISsqDataDocument, SsqDataRepository} from "../repositories/SsqDataRepository";
import {DocType, getDocTypeLangKey} from "../definitions/DocType";
import CategoryCards from "./CategoryCards";
import SsqDocumentsAccordionItem from "./SsqDocumentsAccordionItem";
import {Accordion} from "react-accessible-accordion";
import {
  ProductContents,
  ProductContentsContainer,
  ProductPageContainer,
  ProductTable,
  SsqDataColumnTitles,
  SubTabButtons,
  SubTabTableArea
} from "./ProductPage";
import {RoleType} from "../definitions/RoleType";
import {TargetType} from "../definitions/TargetType";
import {AccountService} from "../repositories/AccountService";
import NotFoundPage from "../NotFoundPage";
import {connect} from "react-redux";
import {IfLoginInfo} from "models/IfLoginInfo";
import {IfSvrConf} from "models/IfSvrConf";
import {langutil} from "language/langutil";
import axios from "axios";
import {getLangSuffix, HelmetTitleAndH1} from "../ctls/common/HelmetTitleAndH1";
import {helmetFormat, tcommona} from "language/i18nkey";
import {loginutil} from "util/loginutil";
import {roleutil} from "util/roleutil";
import {authutil} from "util/authutil";
import {exposeCommunityLink} from "communitypage/CommunityExpose";

interface IProductPageMatchParams {
  documentId: string;
  country?: string;
  lang?: string;
}


interface Props extends RouteComponentProps<IProductPageMatchParams, any> {
  accountService: AccountService;
  languageService: LanguageService;
  categoryRepository: CategoryRepository;
  ssqDataRepository: SsqDataRepository;
  categoryStore: CategoryStore;
  loginInfo: IfLoginInfo;
  svrConf: IfSvrConf;
}

interface State {
  selectedDocumentDetail: ISsqDataDocument;
  isMounted: boolean;
  isBookmark: boolean;
}

class ProductPage extends Component<Props, State> {
  private readonly NO_DATA = "NO_DATA";
  private readonly PAGE_NUM_UNIT = 20;

  constructor(props: Props) {
    super(props);

    this.state = {
      selectedDocumentDetail: emptySsqDataDocument,
      isMounted: false,
      isBookmark: false
    };
  }

  async componentDidMount() {
    await exposeCommunityLink(this.props.match.params.documentId);

    if (!langutil.isCountryLangUrl()) { // url에 국가/언어가 없으면.
      const docId = this.props.match.params.documentId;
      const minInfo: ISsqDataDocMinInfo = (await axios.get('/api/guest/ssqData/docmininfo/' + docId)).data;
      document.location.href = langutil.getCountryLangUrl(minInfo.exposeSiteLanguage);
      return; // 다음으로 진행하지 않도록.
    }

    await this.props.ssqDataRepository.addClickCount(Number(this.props.match.params.documentId));

    await this.loadAllCategories();
    await this.getDocumentDetail();

    //const loggedInAuthority = await this.props.accountService.getLoggedInAuthority();

    //this.verifyUserRole(loggedInAuthority);

    document.getElementById("helmetTitle").innerText += " - " +
      helmetFormat([this.state.selectedDocumentDetail.docTitle, ' - '], 'I18N_COMMON_TIT_PROD', [getLangSuffix()]);

    axios.post(`/api/guest/ssqData/bookmark/check`, {
      userId: this.props.loginInfo.userId,
      docId: this.state.selectedDocumentDetail.id
    }).then(response => {
      if (response.data) {
        this.setState({isBookmark: true});
      }
    });

    this.setState({
      isMounted: true
    });
  }

  async componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>) {
    if (this.props.loginInfo?.apires !== prevProps?.loginInfo?.apires ||
      this.state?.selectedDocumentDetail?.id !== prevState?.selectedDocumentDetail?.id) {
      if (this.state?.selectedDocumentDetail?.id && loginutil.fetched(this.props.loginInfo)) {
        await this.verifyUserRole(loginutil.getrole(this.props.loginInfo), this.props.loginInfo?.userRoles);
      }
    }
  }

  async verifyUserRole(loginAuth: string, userRole: string) {
    if (this.props.svrConf.iscrawler) {
      console.log("crawler useragent : ", this.props.svrConf.userAgent);
      return;
    }
    const dispTarget = this.state.selectedDocumentDetail.displayTarget;
    const pathname = this.props.history.location.pathname;
    const {country, lang} = langutil.splitLangCode(this.props.languageService.lang());
    if (loginAuth === RoleType.ROLE_ANONYMOUS && dispTarget === TargetType.LOGIN) {
      this.props.history.push(`/${country}/${lang}/requireMemberLogin`, pathname);
    } else if ([RoleType.ROLE_ANONYMOUS, RoleType.ROLE_MEMBER].includes(loginAuth) && dispTarget === TargetType.EMPLOYEE) {
      this.props.history.push(`/${country}/${lang}/requireEmployeeLogin`, pathname);
    } else if ([RoleType.ROLE_ANONYMOUS, RoleType.ROLE_MEMBER].includes(loginAuth) && dispTarget === TargetType.PARTNER) {
      !roleutil.hasPartnerChecks(this.props.loginInfo.userId, this.state?.selectedDocumentDetail?.exposeSiteLanguage)
        .then((hasPartner) => {     //파트너계정 + 국가 확인
          if (!hasPartner) {
            this.props.history.push(`/${country}/${lang}/requirePartnerLogin`, pathname);
          }
        });
    }

    // 로그인 확인 에러발생시 ----------------

    //정상적인 케이스는 페이지 보여주고,,,
    if ((loginAuth === RoleType.ROLE_ANONYMOUS && dispTarget === TargetType.GUEST)
      || (loginAuth === RoleType.ROLE_MEMBER && (dispTarget === TargetType.GUEST) || (dispTarget === TargetType.LOGIN))
      || (loginAuth === RoleType.ROLE_ADMIN && (dispTarget === TargetType.GUEST) || (dispTarget === TargetType.LOGIN) || (dispTarget === TargetType.EMPLOYEE) || (dispTarget === TargetType.PARTNER))
    ) {
      // 페이지 보여주고,,,
    }
    // 로그인 확인 에러발생시
    else {
      this.props.history.push(`/${country}/${lang}/requireMemberLogin`, pathname);
    }
  }

  async loadAllCategories() {
    if (this.props.categoryStore.allCategories.length === 0) {
      let language = this.props.languageService.getLanguage();
      const allCategories = await this.props.categoryRepository.getExposedCategories(language);
      await this.props.categoryStore.setAllCategories(allCategories);
    }
  }

  async getDocumentDetail() {
    let documentDetail = await this.props.ssqDataRepository.getSsqDataByDocumentId(Number(this.props.match.params.documentId));

    const docType = documentDetail?.docType;
    if (!authutil.isMatchUrlDocType(docType, document.location.pathname)) {
      const prefix = langutil.countryLangPrefix(document.location.pathname);
      document.location.href = prefix + "/404";
      return;
    }
    if (documentDetail && documentDetail.id) {
      this.setState({
        selectedDocumentDetail: documentDetail
      });
    } else {
      this.setState({
        selectedDocumentDetail: emptySsqDataDocument
      });
    }
  }

  getTranslation(key: string): string {
    this.props.languageService.setNamespace("I18N_NAMESPACE_PRODUCT_PAGE");
    return this.props.languageService.getTranslationByKey(key) || "";
  }

  isEducationResource() {
    return this.state.selectedDocumentDetail.docType === DocType.EDUCATION_NOTE || this.state.selectedDocumentDetail.docType === DocType.EDUCATION_VIDEO;
  }

  renderCategoryArea() {
    return <CategoryCards
      selectedCategoryId={Number(0)}
      categoryRepository={this.props.categoryRepository}
      categoryStore={this.props.categoryStore}
      languageService={this.props.languageService}
      loadAllCategories={this.loadAllCategories.bind(this)}
    />;
  }

  renderDocumentTable() {
    return <>
      <SsqDataColumnTitles>
        <div className={"accordion-col-doc-num"}>{"No."}</div>
        <div className={"accordion-col-doc-title"}>{this.getTranslation("I18N_DOC_COL_NAME")}</div>
        {/*<div className={"accordion-col-description"}>{this.getTranslation("I18N_DOC_COL_DESCRIPTION")}</div>*/}
        <div className={"accordion-col-doc-bookmark"}>{this.getTranslation("I18N_DOC_COL_BOOKMARK")}</div>
        <div className={"accordion-col-doc-share"}>{this.getTranslation("I18N_DOC_COL_SHARE")}</div>
        <div className={"accordion-col-doc-language"}>{this.getTranslation("I18N_DOC_COL_LANG")}</div>
        {/*{this.isEducationResource() &&
          <div
            className={"accordion-col-files"}>{this.getTranslation("I18N_DOC_COL_EDUCATION_VERSION")}</div>}*/}
        <div className={"accordion-col-update-time"}>{this.getTranslation("I18N_DOC_COL_UPDATE_TIME")}</div>
        <div className={"accordion-col-click-count"}>{this.getTranslation("I18N_DOC_COL_VIEWS")}</div>
        <div className={"accordion-col-more"}></div>
      </SsqDataColumnTitles>
      <AccordionWrapper>
        <Accordion allowZeroExpanded>
          <div>
            <SsqDocumentsAccordionItem
              postNum={1}
              document={this.state.selectedDocumentDetail}
              ssqDataRepository={this.props.ssqDataRepository}
              languageService={this.props.languageService}
              categoryStore={this.props.categoryStore}
              loadAllCategories={this.loadAllCategories.bind(this)}
              expendAccordion={true}
              bookmark={this.state.isBookmark}
            />
          </div>
        </Accordion>
      </AccordionWrapper>
    </>;
  }

  renderSubTabButton(docType: string) {
    return <div className={`tab-button ${this.state.selectedDocumentDetail.docType === docType ? "selected" : ""}`}>
      {this.getTranslation(getDocTypeLangKey(docType))} <span>1</span>
    </div>;
  }

  renderDownloadTabPanel() {
    return <div>
      <SubTabButtons style={{padding: "0"}}>
        {this.renderSubTabButton(this.state.selectedDocumentDetail.docType)}
      </SubTabButtons>
      <SubTabTableArea>
        {this.renderDocumentTable()}
      </SubTabTableArea>
    </div>;
  }

  renderProductPageDetail() {
    const {country, lang} = langutil.splitLangCode(this.props.languageService.lang());

    return <ProductPageContainer aria-label={"product-page"}>
      <HelmetTitleAndH1 title={tcommona('I18N_COMMON_TIT_PROD', [this.state.selectedDocumentDetail?.docTitle, ' - '], [getLangSuffix()])}/>
      <TitleBarContainer>
        <TitleBarContents className={"container"}>
          <TitleBarItem><a href={`/${country}/${lang}/main`}>{this.getTranslation("I18N_TITLE_MAIN")}</a></TitleBarItem>
          <TitleBarItem className="selected">{this.getTranslation("I18N_TITLE_PRODUCT")}</TitleBarItem>
        </TitleBarContents>
      </TitleBarContainer>
      <ProductContentsContainer>
        <div className={"wrapper container"}>
          <ProductContents>
            {this.renderCategoryArea()}
          </ProductContents>
          <ProductTable>
            <TabItem style={{padding: "1.6rem 3.2rem 0 3.2rem"}}>
              <Tabs forceRenderTabPanel>
                <TabList>
                  <Tab>{this.getTranslation("I18N_TAB_DOWNLOAD")}</Tab>
                </TabList>
                <TabPanel>
                  {this.renderDownloadTabPanel()}
                </TabPanel>
              </Tabs>
            </TabItem>
          </ProductTable>
        </div>
      </ProductContentsContainer>
    </ProductPageContainer>;
  }

  renderNotFoundPage() {
    return <NotFoundPage languageService={this.props.languageService}/>;
  }

  render() {
    return <div>
      {this.state.isMounted && this.state.selectedDocumentDetail === emptySsqDataDocument ?
        this.renderNotFoundPage() : this.renderProductPageDetail()
      }
    </div>;
  }
}

//export default withRouter(ProductPage);
export default withRouter(connect(
  (state: any) => ({
    loginInfo: state.main.loginInfo,
    svrConf: state.main.svrConf,
  })
)(ProductPage));

const DocumentPageList = styled.div`
  padding: 0 3.2rem;
`;

const AccordionWrapper = styled.div`
  width: 100%;


  .accordion {
    width: 100%;
    color: #2A2C2F;
  }

  .accordion > div:nth-child(even) {
    background: #F7F8FB;
  }
`;